export const CLIENT_ID = 'highmark-cs-allmyhealth-web';
/**
 * @deprecated TEMPORARY while we transition from client-set TenantID to server-set
 */
export const TENANT_ID = 'highmark-cs-allmyhealth';
